/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementCourseAccessViewModel } from "../types/CourseRegistrationManagementCourseAccessViewModel.ts";

export const courseRegistrationManagementCourseAccessViewModelSchema = z.object(
  {
    isReleased: z.optional(
      z
        .boolean()
        .describe("Indica se o acesso ao curso está atualmente liberado."),
    ),
    releasedUntil: z
      .string()
      .datetime()
      .describe("Data limite configurada para o acesso ao curso. Opcional.")
      .nullish(),
    releasedDays: z
      .number()
      .int()
      .describe(
        "Número de dias de acesso configurado a partir do início. Opcional.",
      )
      .nullish(),
    releasedStartDate: z
      .string()
      .datetime()
      .describe("Data de início efetiva do acesso liberado ao curso. Opcional.")
      .nullish(),
    releasedEndDate: z
      .string()
      .datetime()
      .describe(
        "Data de término efetiva do acesso liberado ao curso. Opcional.",
      )
      .nullish(),
  },
) as unknown as ToZod<CourseRegistrationManagementCourseAccessViewModel>;
